import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SharedService {
  private messageSource = new BehaviorSubject('');
  currentMessage = this.messageSource.asObservable();

  private categoriesSource = new BehaviorSubject('');
  currentCategories = this.categoriesSource.asObservable();

  private clientIdSource = new BehaviorSubject(false);
  isClientIdSet = this.clientIdSource.asObservable();

  private urlSource = new BehaviorSubject('');
  previousUrl = this.urlSource.asObservable();
  constructor() {}

  update(e: any) {
    this.messageSource.next(e);
  }

  updateCategories(e: any) {
    this.categoriesSource.next(e);
  }

  updateClientIdSet(e: any) {
    this.clientIdSource.next(e);
  }

  updatePreviousUrl(e: any) {
    this.urlSource.next(e);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/shared.service.ts